<div class="d-flex justify-content-between align-items-center bg-secondary mt-3 w-100 text-white px-4 py-2"
    *ngIf="students.length > 0">
    <label class="fs-5 m-0"><span class="vag-bold-font">DOCUMENTOS</span>
        {{students[studentCurrent].fullname}}</label>
    <div class="d-flex">
        <button [disabled]="!students[studentCurrent - 1]" class="btn mx-1" (click)="decreaseIndex()">
            <fa-icon [icon]="chevronLeft" class="text-white"></fa-icon>
        </button>
        <button [disabled]="!students[studentCurrent + 1]" class="btn mx-1" (click)="increaseIndex()">
            <fa-icon [icon]="chevronRight" class="text-white"></fa-icon>
        </button>
    </div>
</div>
<div class="container_documents pt-3" *ngIf="students.length > 0">
    <div class="my-3" *ngIf="courseCurrent" >
        Curso: <select (change)="chooseCourse($event)">
            <option *ngFor="let course of students[studentCurrent]?.courseInfoArr" value="{{course.id}}">{{course.description}}</option>
        </select> {{courseCurrent.centerDescr}} {{showCourseDays(courseCurrent)}} {{showCourseShedule(courseCurrent)}}
    </div>
    <div class="d-flex border-bottom pb-2 border-black">
        <div class="col vag-bold-font">
            Nombre
        </div>
        <div class="col vag-bold-font">
            DNI/NIE
        </div>
        <div class="col vag-bold-font">
            Tipo de documento
        </div>
        <div class="col vag-bold-font">
            Estado
        </div>
    </div>
    <div class="d-flex border-bottom pb-2 border-black mt-2" *ngFor="let item of documentsType">
        <div class="col">
            {{user.fullname}}
        </div>
        <div class="col">
            {{user.numberDNI}}
        </div>
        <div class="col">
            {{item?.tipo}}
        </div>
        <div class="col-md" *ngIf="showEnviado(item)">
            <a class="is_active" (click)="sendDocumentSigned(item)">Enviado</a>
        </div>
        <div class="col-md" *ngIf="!showEnviado(item)">
            <a class="is_active" (click)="autorizarDocumento(item)">Pendiente</a>
        </div>
    </div>
    <!--<form [formGroup]="form" (ngSubmit)="addNewDocument()">
        <div class="d-flex pb-2 mt-4">
            <div class="col-9">
                <select class="form-control fs-5" formControlName="docType">
                    <option value=""></option>
                    <option value="recogida">Autorización recogida del centro de menores</option>
                    <option value="cesion">Autorización cesión de imágenes</option>
                </select>
            </div>
            <div class="col-3">
                <button class="btn btn-lightblue btn-block" type="submit">Añadir</button>
            </div>
        </div>
    </form>-->
</div>
<div *ngIf="cargando" class="cargando">
    <mat-spinner></mat-spinner>
  </div>